import { getCookie } from '../helpers/cookies';

export const TOKEN = getCookie("account", "app_account_token");
export const FULLNAME = getCookie("account", "app_account_fullname");
export const USERNAME = getCookie("account", "app_account_username");